import { render, staticRenderFns } from "./index.vue?vue&type=template&id=032c3a76&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=032c3a76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookingDialogStepProduct2: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/BookingDialog2/BookingDialogStepProduct2.vue').default,BookingDialogStepShop2: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/BookingDialog2/BookingDialogStepShop2.vue').default,BookingDialogStepShopContact2: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/BookingDialog2/BookingDialogStepShopContact2.vue').default,BookingDialogStepShopConfirmation2: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/BookingDialog2/BookingDialogStepShopConfirmation2.vue').default})
